const DEVConsole = {
  log: (...args) => {
    if (process && process.env && process.env.NODE_ENV === 'development') {
      console.log(...args);
    }
  },
  warn: (...args) => {
    if (process && process.env && process.env.NODE_ENV === 'development') {
      console.warn(...args);
    }
  },
  error: (...args) => {
    if (process && process.env && process.env.NODE_ENV === 'development') {
      console.error(...args);
    }
  },
};

export default DEVConsole;
